var _Alert;
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { Alert, CheckboxWithVisual, InfoIcon, Text } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const oneClickLabel = /*#__PURE__*/_jsxs(_Fragment, {
  children: ["Enable one-click email to dealers", /*#__PURE__*/_jsx(InfoIcon, {
    placement: "top",
    popoverId: "oneClickInfo",
    className: "margin-left-1",
    infoText: "We\u2019ll save your email settings so you can contact the seller on any vehicle listing with just one-click."
  })]
});

/**
 *  The OneClickOptIn component allows the user to select whether to enable One-Click,
 *  and will display the current status.
 *
 */
function OneClickOptIn(_ref) {
  let {
    handleOneClickCheck = () => {},
    listingId,
    isOneClickChecked = false
  } = _ref;
  const handleOneClickOptInCheck = useCallback(event => {
    handleOneClickCheck(event);
    sendClick('oneClickButtonClick', event, {
      listingId,
      element: 'checkbox',
      content: !isOneClickChecked ? 'opt-in' : 'opt-out'
    });
  }, [handleOneClickCheck, isOneClickChecked, listingId]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "row",
      children: /*#__PURE__*/_jsx(CheckboxWithVisual, {
        name: "oneClickOptIn",
        label: oneClickLabel,
        checked: isOneClickChecked,
        onClick: handleOneClickOptInCheck,
        withCheckmark: "false",
        uiContext: "landscape",
        secondaryLabel: "You can opt-out at anytime"
      })
    }), isOneClickChecked && (_Alert || (_Alert = /*#__PURE__*/_jsxs(Alert, {
      "data-cmp": "oneClickOptInAlert",
      bsStyle: "info",
      className: "margin-top-2 margin-bottom-3",
      children: [/*#__PURE__*/_jsx(Text, {
        weight: "bold",
        children: "One-click email enabled."
      }), ' ', "Emails will be sent to dealers with one-click on any vehicle listing."]
    })))]
  });
}
export default OneClickOptIn;